export default {
  // Action bar
  addAssign: 'Add Assignment',
  // Search
  batchNo: 'Batch No.',
  batchNoPlaceholder: 'Enter batch no.',
  codeSn: 'QR Code',
  codeSnPlaceholder: 'Enter QR code',
  productName: 'Product Name',
  productNamePlaceholder: 'Enter product name',
  productSn: 'Product No.',
  productSnPlaceholder: 'Enter product no.',
  productionBatch: 'Production Batch',
  productionBatchPlaceholder: 'Enter production batch',
  // Table columns
  colProductInfo: 'Product Info',
  colProductionBatch: 'Production Batch',
  colBatchNo: 'Batch No.',
  colQrcodeRange: 'QR Code Range',
  colCount: 'Quantity',
  colRemark: 'Remark',
  colCreatedAt: 'Created At',
  colOperator: 'Operator',
  colAction: 'Action',
  // Product info
  productNo: 'Product No.',
  // Production batch
  batchId: 'ID',
  // Actions
  delete: 'Delete',
  // Add assignment modal
  addAssignTitle: 'Add Product Code Assignment',
  batchNoLabel: 'Batch No.',
  selectBatch: 'Select',
  rangeType: 'Range Type',
  rangeTypeAll: 'All',
  rangeTypeRange: 'Range',
  assignType: 'Assignment Type',
  assignTypeProduct: 'By Product',
  assignTypeProductionBatch: 'By Production Batch',
  startQrcode: 'Start QR Code',
  endQrcode: 'End QR Code',
  relatedProduct: 'Related Product',
  selectProduct: 'Select Product',
  remarkLabel: 'Remark',
  remarkPlaceholder: 'Enter remark',
  batchNoRequired: 'Please select a batch',
  productRequired: 'Please select a product',
  productionBatchRequired: 'Please select a production batch',
  selectProductionBatch: 'Select',
  startQrcodeRequired: 'Please enter start QR code',
  endQrcodeRequired: 'Please enter end QR code',
  // Delete confirm
  deleteConfirmTitle: 'Confirm Delete',
  deleteConfirmContent: 'Are you sure to delete this assignment record?',
  // Empty state
  emptyText: 'No assignment records',
};
